import { Quotes, DownloadSimple } from "@phosphor-icons/react";

export const FounderStatement = () => (
  <section className="max-w-4xl mx-auto px-6 py-16" data-testid="founder-statement">
    <div className="border-2 border-[#0D1B2A] bg-white p-8 sm:p-12 relative">
      <Quotes size={40} weight="fill" className="text-[#B47A3C] absolute -top-5 left-8 bg-white px-1" />
      <p className="label-caps text-[#B47A3C] mb-4">A seller tool first — and a knowledge base that learns from seller expertise</p>
      <blockquote className="font-serif-display text-xl sm:text-2xl leading-relaxed text-[#0D1B2A] space-y-4">
        <p>
          &ldquo;The goal is not to compete with the marketplaces this app works with. The goal is to design
          interactions where value <em className="text-[#B47A3C]">compounds</em> instead of being unnecessarily
          destroyed.
        </p>
        <p>
          Sellers save countless hours and keep control of the work they've already done. Marketplaces enjoy
          more listings and more sales. And over time, the market gains specialized insights it has never had.
        </p>
        <p>
          <strong>Everyone wins</strong> — starting with putting control back in the hands of the sellers,
          inside a looped system that makes every stage easier each time one of our sellers lists.&rdquo;
        </p>
      </blockquote>
      <div className="mt-6 flex flex-wrap items-center gap-4">
        <p className="text-[15px] font-semibold text-[#8A867D]" data-testid="founder-statement-attribution">
          — Nichole, <span className="text-[#B47A3C]">Founder</span>
        </p>
        <a
          href="/founder_statement_card.png"
          download="vintage-vantage-founder-statement.png"
          data-testid="founder-statement-download"
          className="inline-flex items-center gap-1.5 text-sm font-semibold text-[#B47A3C] hover:text-[#0D1B2A] transition-colors border border-[#B47A3C]/40 px-3 py-1.5"
        >
          <DownloadSimple size={15} weight="bold" /> Share this — download the quote card
        </a>
      </div>
    </div>
  </section>
);
